module.exports = __webpack_public_path__ + "static/media/junto.4ccf6433.svg";